<template>
  <div class="login-modular">
    <div class="header-modular">
      <headerInfo ref="headerModular" :number="cartNum"></headerInfo>
    </div>
    <div class="logo-modular">
      <!-- ../assets/public/logo.png -->
      <img class="logo-img" :src="logo" alt="" @click="toIndex" />
      <div class="btn-modular">
        <div
          :class="btnName == 'login' ? 'login-btn click-btn' : 'login-btn'"
          @click="clickLogin"
        >
          {{ pageTextArr[1] }}
        </div>
        <div
          :class="btnName == 'register' ? 'login-btn click-btn' : 'login-btn'"
          @click="clickRegister"
        >
          {{ currLanguage == 3 ? "Register" : pageTextArr[2] }}
        </div>
      </div>

      <div
        v-if="btnName == 'login'"
        class="form-msg"
        style="margin-bottom: 245px"
      >
        <input class="fake-input" type="text" name="fakeusernameremembered" />
        <input
          class="fake-input"
          type="password"
          name="fakepasswordremembered"
        />

        <div class="login-input">
          <span class="title">{{ pageTextArr[3] }}</span>
          <input type="text" class="account padding20" v-model="loginEmail" />
        </div>
        <div class="login-input">
          <span class="title">{{ pageTextArr[4] }}</span>
          <input
            type="password"
            class="password padding20"
            v-model="loginEmailPwd"
          />
        </div>
        <div class="forget-password" @click="toForgetPassword">
          <span>{{ pageTextArr[5] + "?" }}</span>
        </div>
        <div>
          <button type="button" class="login-button" @click="userLogOn()">
            {{ pageTextArr[1] }}
          </button>
        </div>
        <!-- <div class="third-party-login">
          <span class="third-party">第三方登录</span>
          <div class="line"></div>
        </div> -->
        <!-- <div class="login-type">
          <img src="../assets/login-icon/QQ.png" alt="" class="login-icon" />
          <img
            src="../assets/login-icon/weixin.png"
            alt=""
            class="login-icon"
          />
          <img
            src="../assets/login-icon/google.png"
            alt=""
            class="login-icon"
          />
          <img
            src="../assets/login-icon/paypal.png"
            alt=""
            class="login-icon"
          />
          <img src="../assets/login-icon/vk.png" alt="" class="login-icon" />
        </div> -->
      </div>
      <div v-else class="form-msg">
        <div class="name-modular">
          <div class="name-input login-input">
            <span class="title">
              <span class="red-color">*</span>
              {{ pageTextArr[6] }}</span
            >
            <el-input
              class="account padding20"
              v-model="registerData.name"
            ></el-input>
          </div>
          <div class="name-input login-input">
            <span class="title">
              <span class="red-color">*</span>
              {{ pageTextArr[7] }}</span
            >
            <el-input
              class="account padding20"
              v-model="registerData.surname"
            ></el-input>
          </div>
        </div>
        <div class="login-input">
          <span class="title">
            <span class="red-color">*</span>
            {{ pageTextArr[3] }}</span
          >
          <el-input
            class="account padding20"
            v-model="registerData.email"
          ></el-input>
        </div>
        <div class="login-input" style="height: 55px; margin-top: 20px">
          <span class="title phone-title">
            <span class="red-color">*</span>
            {{ pageTextArr[8] }}</span
          >
          <div class="phone-prefix-modular">
            <el-select
              v-model="currTel"
              filterable
              class="country-tel-select"
              :placeholder="pageTextArr[0]"
            >
              <el-option
                v-for="item in countryTelData"
                :key="item.id"
                :label="item.area_code"
                :value="item.area_code"
              >
              </el-option>
            </el-select>
            <el-input
              class="account padding100 phone-suffix country-tel-input"
              v-model="registerData.mobile"
            ></el-input>
          </div>
        </div>
        <div class="login-input" style="margin-top: 16px">
          <span class="title" style="top: 3px">
            <span class="red-color">*</span>
            {{ pageTextArr[9] }}</span
          >
          <div>
            <input
              class="fake-input"
              type="text"
              name="fakeusernameremembered"
            />
            <input
              class="fake-input"
              type="password"
              name="fakepasswordremembered"
            />
          </div>

          <el-input
            type="password"
            class="account padding20"
            v-model="registerData.password"
          ></el-input>
        </div>
        <div class="login-input">
          <span class="title">
            <span class="red-color">*</span>
            {{ pageTextArr[10] }}</span
          >
          <el-input
            type="password"
            class="account padding20"
            v-model="registerData.confirm_password"
          ></el-input>
        </div>
        <div class="login-input">
          <span class="title">
            <span class="red-color">*</span>
            {{ pageTextArr[11] }}</span
          >
          <el-select
            v-model="currCountryId"
            filterable
            class="country-select-select"
            :placeholder="pageTextArr[0]"
          >
            <el-option
              v-for="item in countryData"
              :key="item.id"
              :label="currLanguage != 1 ? item.english_name : item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="login-input">
          <span class="title">{{ pageTextArr[12] }}</span>
          <el-input
            class="account padding20"
            v-model="registerData.company"
          ></el-input>
        </div>
        <div>
          <button type="button" class="login-button" @click="register()">
            {{ pageTextArr[2] }}
          </button>
        </div>
        <div class="agree-modular">
          <el-checkbox
            v-model="agreeChecked"
            class="agree-checkbox"
          ></el-checkbox>
          <div class="agree-text">
            {{ pageTextArr[13]
            }}<span
              class="red-color"
              @click="toPrivacys"
              style="cursor: pointer"
            >
              {{ pageTextArr[14] }}
            </span>
            {{ pageTextArr[15] }}
            <span class="red-color" @click="toPrivacy" style="cursor: pointer"
              >{{ pageTextArr[16] }} </span
            >{{ pageTextArr[17] }}
          </div>
        </div>
      </div>
    </div>
    <footerInfo></footerInfo>
  </div>
</template>
<script>
import headerInfo from "../components/public/headerInfo";
import footerInfo from "../components/public/footerInfo";

export default {
  components: {
    headerInfo,
    footerInfo,
  },
  data() {
    return {
      logo: "",
      cartNum: 0,
      currLanguage: 1, //当前语言
      countryTelData: [], //电话区域数据
      countryData: [], //国家数据
      currCountryId: "", //当前国家
      currTel: "", //国家tel
      agreeChecked: false, //注册-同意
      btnName: "login",
      phonePrefix: "+86",
      nation: "中国",
      loginEmail: "", //18839800564@163.com
      loginEmailPwd: "", //123456
      password: "12132", //that.loginEmailPwd
      registerData: {
        name: "", //名
        surname: "", //姓
        mobile: "", //手机号
        email: "", //邮箱
        password: "", //密码
        confirm_password: "", //确认密码
        country_id: "", //国家id
        company: "", //公司名
      },
      pageText: {
        placeholderText: "请选择-0",
        loginText: "登录-1",
        registerText: "注册-2",
        emailText: "邮箱-3",
        pwdText: "密码-4",
        forgetpwdText: "忘记密码5",
        nameText: "名6",
        surnameText: "姓7",
        mobileText: "电话8",
        setPwdText: "设置密码",
        confirmpwdText: "确认密码",
        countryText: "国家",
        company: "公司",
        agreeText1: "我已阅读并同意",
        agreeText2: "使用条件",
        agreeText3: "及",
        agreeText4: "隐私声明",
        agreeText5: "，并同意我的部分个人信息将根据隐私声明在境外处理。",
      },
      pageTextArr: [
        "请选择",
        "登录",
        "注册",
        "邮箱",
        "密码",
        "忘记密码",
        "名",
        "姓",
        "电话",
        "设置密码",
        "确认密码",
        "国家",
        "公司",
        "我已阅读并同意",
        "使用条件",
        "及",
        "隐私声明",
        "，并同意我的部分个人信息将根据隐私声明在境外处理。",
      ],
      pageTextArrs: [
        "请填写邮箱",
        "请填写密码",
        "登录成功",
        "登录失败，请查看账号密码是否正确",
        "请勾选隐私政策，以提供服务",
        "请填写名字",
        "请填写姓氏",
        "请填写电话",
        "请填写确认密码",
        "注册成功",
        "注册失败，该邮箱已被注册",
      ],
      detail: "",
    };
  },
  methods: {
    clickLogin() {
      this.btnName = "login";
      this.loginEmail = "";
      this.loginEmailPwd = "";
    },
    /**
     * 点击图标可跳转到首页
     */
    toIndex() {
      this.$router.push({
        path: "/",
      });
    },
    /**
     * 注册
     */
    clickRegister() {
      let that = this;
      that.registerData.name = "";
      that.registerData.surname = "";
      that.registerData.mobile = "";
      that.registerData.email = "";
      that.registerData.mobile = "";
      that.registerData.password = "";
      that.registerData.confirm_password = "";
      that.registerData.country_id = "";
      that.registerData.company = "";
      that.currTel = "";
      // 获取国家列表
      that.getCountry();
      that.btnName = "register";
    },

    /**
     * 密码
     */
    toForgetPassword() {
      this.$router.push({
        path: "/forgetPassword",
      });
    },

    /**
     * 获取国家列表
     */
    getCountry() {
      let that = this;
      this.$http.getCountry(
        null,
        (res) => {
          that.countryData = res.data;
          that.countryTelData = res.data;
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 登录
     */
    userLogOn() {
      // 清空缓存
      // localStorage.clear();
      let that = this;
      let data = {
        email: that.loginEmail,
        password: that.loginEmailPwd,
        cookie:this.getCookies()
      };
      if (that.loginEmail == "") {
        // 名
        this.$message.warning(
          that.currLanguage == 3
            ? "Please fill in the email address"
            : this.pageTextArrs[0]
        );
        return;
      }
      if (that.loginEmailPwd == "") {
        // 名
        this.$message.warning(
          that.currLanguage == 3
            ? "Please fill in the password"
            : this.pageTextArrs[1]
        );
        return;
      }
      this.$http.emailLogin(
        data,
        (res) => {
          if (res.ret == 1) {
            this.$message.success(this.pageTextArrs[2]);
            localStorage.setItem("token", res.data.accesstoken); //token
            localStorage.setItem("isLogin", 1);
            localStorage.setItem("genericBaseUrl", "https://admin.ginkgoem.cn");
            // cartCount
            localStorage.setItem("cartCount", res.data.cartCount); //token
            if (localStorage.getItem("url")) {
              //   this.$router.push({
              //   path: localStorage.getItem("url"),
              // });
              let url =localStorage.getItem("url")
              window.location.href = url;
            } else {
              this.$router.push({
                path: "/",
              });
            }
            this.loginEmail = "";
            this.loginEmailPwd = "";
          } else {
            this.$message.error(this.pageTextArrs[3]);
          }
        },
        (res) => {
          this.$message.error(this.pageTextArrs[3]);
        }
      );
    },

    /**
     * 点击注册
     */
    register() {
      let that = this;
      if (!that.agreeChecked) {
        // 隐私政策
        this.$message.warning(
          that.currLanguage == 3
            ? "Please check the privacy policy to provide services"
            : this.pageTextArrs[4]
        );
      } else {
        if (that.registerData == "") {
          // 名
          this.$message.warning(
            that.currLanguage == 3
              ? "Please fill in the first name"
              : this.pageTextArrs[5]
          );
          return;
        } else if (that.surname == "") {
          // 姓
          this.$message.warning(
            that.currLanguage == 3
              ? "Please fill in the last name"
              : this.pageTextArrs[6]
          );
          return;
        } else if (that.email == "") {
          // 邮箱
          this.$message.warning(
            that.currLanguage == 3
              ? "Please fill in the email"
              : this.pageTextArrs[0]
          );
          return;
        } else if (that.mobile == "") {
          // 电话
          this.$message.warning(
            that.currLanguage == 3
              ? "Please fill in the mobile"
              : this.pageTextArrs[7]
          );
          return;
        } else if (that.password == "") {
          //认密码
          this.$message.warning(
            that.currLanguage == 3
              ? "Please fill in the password"
              : this.pageTextArrs[1]
          );
          return;
        } else if (that.confirm_password == "") {
          // 确认密码
          this.$message.warning(
            that.currLanguage == 3
              ? "Please fill in the confirm password"
              : this.pageTextArrs[8]
          );
          return;
        } else {
          // 注册
          that.userRegister();
        }
      }
    },

    /**
     * 注册
     */
    userRegister() {
      let that = this;
      that.registerData.country_id = that.currCountryId;
      let data = that.registerData;
      this.$http.userRegister(
        data,
        (res) => {
          if (res.ret == 1) {
            this.$message.success(this.pageTextArrs[9]);
            // 返回注册
            that.clickLogin();
          } else {
            this.$message.error(this.pageTextArrs[10]);
          }
        },
        (res) => {
          this.$message.error(this.pageTextArrs[10]);
        }
      );
    },

    /**
     * 语言翻译 - 单个
     * @param {*} text
     * @param {*} callback
     * @param {*} errCallBack
     */
    translate(text, callback, errCallBack) {
      let that = this;
      let data = {
        text: text, //带翻译文本
        from: localStorage.getItem("oldLanguageCode"), //源语言
        to: localStorage.getItem("curLanguageCode"), //目标语言
      };
      if (data.from == data.to) {
        return;
      }
      this.$http.translate(data, callback, errCallBack);
    },

    /**
     * 语言翻译
     * @param {*} text
     */
    languageTranslate(text) {
      let that = this;
      let newText = "";
      this.translate(
        text,
        (res) => {
          that.processingResults(res.data);
          // that.pageText[param] = newText;
        },
        (res) => {
          newText = "";
        }
      );
    },

    /**
     * 处理翻译返回的结果
     * @param {*} param
     */
    pageTranslate(param) {
      let that = this;
      let transformText = "";
      for (const key in that.pageText) {
        transformText += key + ":" + that.pageText[key] + "&";
      }

      that.languageTranslate(transformText);
    },

    /**
     * 处理返回的结果
     */
    processingResults(data) {
      let that = this;
      let textArr = data.split("&amp;");

      textArr.forEach((v, i) => {
        if (v != "") {
          for (const key in that.pageText) {
            if (v.split(":")[0] == key) {
              that.pageText[key] = v.split(":")[1];
            }
          }
        }
      });
    },
    toPrivacy() {
      this.$router.replace(
        {
          path: "/newsPolicy",
          query: {
            titleName: this.currLanguage == 3 ? "Customer service" : "客户服务",
            itemName:
              this.currLanguage == 3 ? "Privacy and Security" : "隐私与安全",
            id: 23,
          },
        },
        () => {}
      );
      localStorage.setItem("detail", this.detail);
    },
    toPrivacys() {
      this.$router.replace(
        {
          path: "/newsPolicy",
          query: {
            titleName:
              this.currLanguage == 3 ? " Customer service " : "客户服务",
            itemName:
              this.currLanguage == 3 ? " Privacy and Security " : "使用条件",
            id: 30,
          },
        },
        () => {}
      );
      localStorage.setItem("detail", this.detail);
    },
    getBottomList() {
      this.$http.getBottomList(null, (res) => {
        if (res.ret == 1) {
          console.log(res);
          this.detail =
            this.currLanguage == 3
              ? res.data[1].child[2].eng_detail
              : res.data[1].child[2].detail;
        }
      });
    },
    /**
     * 获取网站logo以及名称
     */
    getSystemConfig() {
      this.$http.getSystemConfig({}, (res) => {
        if (res.ret == 1) {
          this.logo = res.data.sys_site_logo;
        }
      });
    },

    /**
     * 语言翻译 - 数组
     * @param {*} arr
     * @param {*} callback
     * @param {*} errCallBack
     */
    translateByArr(arr, callback, errCallBack) {
      let that = this;
      let data = {
        text: arr, //带翻译数组
        from: localStorage.getItem("oldLanguageCode"), //源语言
        to: localStorage.getItem("curLanguageCode"), //目标语言
      };
      if (data.from == data.to) {
        return;
      }
      this.$http.translateByArr(data, callback, errCallBack);
    },

    languageTranslateByArr(arr) {
      let that = this;
      let newpagetextArr = [];
      that.translateByArr(arr, (res) => {
        console.log("res", res);
        res.data.forEach((item, index) => {
          newpagetextArr.push(item.translation);
        });
        that.pageTextArr = newpagetextArr;
      });
    },
    languageTranslateByArrs(arr) {
      let that = this;
      let newpagetextArr = [];
      that.translateByArr(arr, (res) => {
        console.log("res", res);
        res.data.forEach((item, index) => {
          newpagetextArr.push(item.translation);
        });
        that.pageTextArrs = newpagetextArr;
      });
    },
  },
  mounted() {
    let that = this;
    //  当前语言
    that.currLanguage = localStorage.getItem("curLanguageType");
    // 获取国家列表
    // that.getCountry();

    that.getSystemConfig();
    // 翻译 -单个
    // that.pageTranslate();
    // that.getBottomList();

    that.languageTranslateByArr(that.pageTextArr);
    that.languageTranslateByArrs(that.pageTextArrs);
  },
};
</script>
<style scoped>
* {
  box-sizing: border-box;
}
input:-webkit-autofill {
  box-shadow: 0 0 0px 1000px #ffffff inset;
}
.el-input__inner:-webkit-autofill {
  box-shadow: 0 0 0px 1000px #ffffff inset;
}
</style>


// WEBPACK FOOTER //
// src/view/login.vue